/**
 * Cookie Consent 组件入口
 * 包含 Banner + Settings Modal
 */

import React from 'react';
import CookieBanner from './CookieBanner';
import CookieSettings from './CookieSettings';

export default function CookieConsent() {
  return (
    <>
      <CookieBanner />
      <CookieSettings />
    </>
  );
}

export { CookieBanner, CookieSettings };

